import { useContext } from 'react';
import { OptimizelyContext } from 'lib/optimizely/optimizely';
import { OptimizelyContextValue } from 'lib/optimizely/optimizely.types';

interface Result {
  isPointsRedemptionStrikethrough: boolean;
  tooltipMessage?: string;
  campaignMessage?: string;
  disclaimer?: string;
  hideBlueBanner?: boolean;
}

const FEATURE_FLAG_NAME = 'qantas-hotels-points-redemption-strikethrough';

const usePointsRedemptionStrikethrough = (): Result => {
  const optimizelyContext = useContext(OptimizelyContext) as OptimizelyContextValue;
  const decision = optimizelyContext?.decisions?.[FEATURE_FLAG_NAME];

  const isReady = optimizelyContext?.isReady ?? false;
  const { enabled = false, variables } = decision || {};

  if (!isReady) {
    return {
      isPointsRedemptionStrikethrough: false,
      tooltipMessage: undefined,
      campaignMessage: undefined,
      disclaimer: undefined,
      hideBlueBanner: true,
    };
  }

  return {
    isPointsRedemptionStrikethrough: enabled,
    tooltipMessage: enabled ? variables?.tooltip : undefined,
    campaignMessage: enabled ? variables?.campaign_message : undefined,
    disclaimer: enabled ? variables?.disclaimer : undefined,
    hideBlueBanner: enabled ? variables?.hide_blue_banner : undefined,
  };
};

export default usePointsRedemptionStrikethrough;
